"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderHTMLStringSafely = exports.sanitizeHTMLString = void 0;
const DOMPurify = __importStar(require("dompurify"));
const unsafe_html_js_1 = require("lit-html/directives/unsafe-html.js");
function sanitizeHTMLString(html) {
    const targetBlankConfig = { ADD_ATTR: ['target'] };
    return DOMPurify.sanitize(html, targetBlankConfig);
}
exports.sanitizeHTMLString = sanitizeHTMLString;
function renderHTMLStringSafely(htmlString) {
    return (0, unsafe_html_js_1.unsafeHTML)(sanitizeHTMLString(htmlString));
}
exports.renderHTMLStringSafely = renderHTMLStringSafely;
